export const VIDEOS = {
  teachMeToLove:
    "https://customer-assets-0z36b82j.emergentagent.net/job_singer-derrick-hall/artifacts/qiofjeqb_Teach_Me_to_love.mp4",
  iWantToKnowChrist:
    "https://customer-assets-0z36b82j.emergentagent.net/job_singer-derrick-hall/artifacts/pe8pzoll_I_Want_To_Know_Christ.mp4",
  praiseMedley:
    "https://customer-assets-0z36b82j.emergentagent.net/job_singer-derrick-hall/artifacts/11mvy9zx_Praise_Medley.mp4",
  oHolyNight:
    "https://customer-assets-0z36b82j.emergentagent.net/job_singer-derrick-hall/artifacts/09dbmc63_O_Holy_Night.mp4",
  moreThanWonderful:
    "https://customer-assets-0z36b82j.emergentagent.net/job_singer-derrick-hall/artifacts/pynq82p4_More_Than_Wonderful.mp4",
};

export const IMAGES = {
  micHero:
    "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwbWljcm9waG9uZSUyMHN0YWdlJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4OTEwNzgxMnww&ixlib=rb-4.1.0&q=85",
  stageBeam:
    "https://images.unsplash.com/photo-1693164445703-7fb161aac083?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHx0aGVhdGVyJTIwc3RhZ2UlMjBsaWdodHMlMjBhbWJlciUyMHNwb3RsaWdodHxlbnwwfHx8fDE3ODkxMDc4MTF8MA&ixlib=rb-4.1.0&q=85",
  spotlight:
    "https://images.unsplash.com/photo-1585236820787-8cb3b8f97613?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHx0aGVhdGVyJTIwc3RhZ2UlMjBsaWdodHMlMjBhbWJlciUyMHNwb3RsaWdodHxlbnwwfHx8fDE3ODkxMDc4MTF8MA&ixlib=rb-4.1.0&q=85",
  pianoKeys:
    "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxhY291c3RpYyUyMG11c2ljJTIwaW5zdHJ1bWVudCUyMHBpYW5vJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODkxMDc4MTJ8MA&ixlib=rb-4.1.0&q=85",
  micStand:
    "https://images.unsplash.com/photo-1629327896333-7ecec1515ae5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHx2aW50YWdlJTIwbWljcm9waG9uZSUyMHN0YWdlJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4OTEwNzgxMnww&ixlib=rb-4.1.0&q=85",
};
